import { useIntl } from 'react-intl';
import { type IChallengeCarouselItem, type IPageItemSettings } from '../../../../common/interfaces';
import { Carousel } from '../Carousel/Carousel';
import { ChallengeCarouselSlide } from './ChallengeCarouselSlide';

interface IChallengeCarouselProps {
  slidesData: IChallengeCarouselItem[];
  settings: IPageItemSettings;
}

export const ChallengeCarousel = ({ slidesData, settings }: IChallengeCarouselProps) => {
  const intl = useIntl();
  const { hideDescription } = settings;
  const slides = slidesData.map((slide) => (
    <ChallengeCarouselSlide key={slide.id} slideData={slide} hideDescription={Boolean(hideDescription)} />
  ));

  return (
    <section id="challenge-carousel-container">
      <Carousel
        data-testid="challenge-carousel"
        slides={slides}
        slidesLabels={slidesData.map((slide) => `${slide.title}`)}
        slidesAriaLabels={slidesData.map(
          (slide) =>
            `${slide.title}, ${slide.subtitle}, ${intl.formatMessage({ id: 'ideasCount', defaultMessage: 'Ideas count' })}: ${slide.ideaCount}.`
        )}
      />
    </section>
  );
};
